import React, { useState } from 'react';
import { connect } from 'react-redux';
import Valg, { DisplayValue } from '../../Shared/Scripts/Models/Valg';
import VeilederStegComponent, { VeilederStegDefaultProps, VeilederStegBaseProps } from '../../Shared/Scripts/Components/VeilederStegComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import ForelopigUttalelseSkjemaSideDto from '../Models/ForelopigUttalelseSkjemaSideDto';
import { ForelopigUttalelseSkjemaSideAppState } from '../Store';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import { StegVisning } from '../../Shared/Scripts/Store/StegVisning/Types';
import SelectOptionDisplay from '../../Shared/Scripts/Components/SelectOptionComponent';
import * as ValgTypes from '../Store/Valg/Types';
import { LegendWithErrorComponent } from '../../Shared/Scripts/Components/LegendWithErrorComponent';
import { focusInputElementOnError } from '../util/input-focus';

type Steg4bComponentOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    ledetekst: JSX.Element | null,
    onChange: any,
    value?: Valg<ValgTypes.Periode>,
}

const FEILMELDING_PERIODE_ID_DEL_GRAD = "feilmelding-periode-delgrad"

type Steg4bDisplayProps = Steg4bComponentOwnProps & MapStateToProps & MapDispatchToProps;

function Steg4bComponentVisning(props: Steg4bDisplayProps): JSX.Element {

    const { epiContext } = props;
    const [inputFraManed, setInputFraManed] = useState<Valg<string>>();
    const [inputFraAar, setInputFraAar] = useState<Valg<string>>();
    const [inputTilManed, setInputTilManed] = useState<Valg<string>>();
    const [inputTilAar, setInputTilAar] = useState<Valg<string>>();
    const [isInErrorState, setIsInErrorState] = useState<boolean>(false);

    let tmpInputFraManed: Valg<string>;
    let tmpInputFraAar: Valg<string>;
    let tmpInputTilManed: Valg<string>;
    let tmpInputTilAar: Valg<string>;

    function onSelectFraAarHandling(nyttFraValg: Valg<string>): void {
        skjulDatoFeilmelding();
        setInputFraAar(nyttFraValg);
        tmpInputFraAar = nyttFraValg;
    }

    function onSelectFraMaanedHandling(nyttFraValg: Valg<string>): void {
        skjulDatoFeilmelding();
        setInputFraManed(nyttFraValg);
        tmpInputFraManed = nyttFraValg;
    }

    function onSelectTilAarHandling(nyttTilValg: Valg<string>): void {
        skjulDatoFeilmelding();
        setInputTilAar(nyttTilValg);
        tmpInputTilAar = nyttTilValg;
    }

    function onSelectTilMaanedHandling(nyttTilValg: Valg<string>): void {
        skjulDatoFeilmelding();
        setInputTilManed(nyttTilValg);
        tmpInputTilManed = nyttTilValg;
    }

    function hentFraAarListe(): DisplayValue[] {
        let aar: DisplayValue[] = [];
        const aarets: number = new Date().getFullYear();
        for(let i = 0;i<3;i++) {
            aar.push({id: ''+(aarets+i), displayValue: ''+(aarets+i)});
        }
        return aar; 
    }

    function hentTilAarListe(): DisplayValue[] {
        let aar: DisplayValue[] = [];
        const aarets: number = new Date().getFullYear();
        for(let i = 0;i<3;i++) {
            aar.push({id: ''+(aarets+i), displayValue: ''+(aarets+i)});
        }
        return aar; 
    }

    function hentMaanedListe(): DisplayValue[] {
        
        if(window.location.href.toLowerCase().indexOf('/en-us/') > 0) {
            //engelske månedsnavn
            return [{id: '01', displayValue: 'January'}, {id: '02', displayValue: 'February'}, {id: '03', displayValue: 'March'}, {id: '04', displayValue: 'April'}, {id: '05', displayValue: 'May'}, {id: '06', displayValue: 'June'}, {id: '07', displayValue: 'July'}, {id: '08', displayValue: 'August'}, {id: '09', displayValue: 'September'}, {id: '10', displayValue: 'October'}, {id: '11', displayValue: 'November'}, {id: '12', displayValue: 'December'}];
        } else {
            //norske månedsnavn
            return [{id: '01', displayValue: 'Januar'}, {id: '02', displayValue: 'Februar'}, {id: '03', displayValue: 'Mars'}, {id: '04', displayValue: 'April'}, {id: '05', displayValue: 'Mai'}, {id: '06', displayValue: 'Juni'}, {id: '07', displayValue: 'Juli'}, {id: '08', displayValue: 'August'}, {id: '09', displayValue: 'September'}, {id: '10', displayValue: 'Oktober'}, {id: '11', displayValue: 'November'}, {id: '12', displayValue: 'Desember'}];
        }
    }

    function getFraAar(aar: Valg<string> | undefined) {
        if(aar === undefined)
            return '';

        return aar.id;
    }

    function getMaaned(maaned: Valg<string> | undefined) {
        if(maaned === undefined)
            return '';

        const maaneder: DisplayValue[] = hentMaanedListe();
        for(let i = 0;i<maaneder.length;i++) {
            if(maaneder[i].id === maaned.id)
                return maaneder[i].displayValue;
        }

        return maaned.id;
    }

    function buttonClickHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();
        
        if(enableNesteKnapp()){
            return;
        }

        props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:true});

        const fraAar: string = getFraAar(inputFraAar);
        const fraMaaned: string = getMaaned(inputFraManed);

        const tilAar: string = getFraAar(inputTilAar);
        const tilMaaned: string = getMaaned(inputTilManed);

        let valgte: Valg<ValgTypes.Periode> = { id:'periode', displayValue: fraMaaned + ' ' + fraAar + ' - ' + tilMaaned + ' ' + tilAar, value: { fraAar: fraAar, fraMaaned: fraMaaned, tilAar: tilAar, tilMaaned: tilMaaned } }
        
        props.onChange(valgte);
    }

    function enableNesteKnapp(): boolean {
        if(validateForm()) {
            skjulDatoFeilmelding();
            return false;
        } 
        visDatoFeilmelding();
        return true;
    }

    function validateForm(): boolean {

        if(inputFraManed === undefined ||inputFraAar === undefined || inputTilAar === undefined || inputTilManed === undefined) return false;

        let fra: Date = new Date();
        let til: Date = new Date();

        if(tmpInputFraManed !== undefined && inputFraAar !== undefined) {
            fra = hentDato(tmpInputFraManed, inputFraAar);
        }
        else if(inputFraManed !== undefined && tmpInputFraAar !== undefined) {
            fra = hentDato(inputFraManed, tmpInputFraAar);
        }
        else if(inputFraManed !== undefined && inputFraAar !== undefined) {
            fra = hentDato(inputFraManed, inputFraAar);
        }

        if(tmpInputTilManed !== undefined && inputTilAar !== undefined) {
            til = hentDato(tmpInputTilManed, inputTilAar);
        }
        else if(inputTilManed !== undefined && tmpInputTilAar !== undefined) {
            til = hentDato(inputTilManed, tmpInputTilAar);
        }
        else if(inputTilManed !== undefined && inputTilAar !== undefined) {
            til = hentDato(inputTilManed, inputTilAar);
        }

        if(til < fra)
            return false;

        return true;
    }

    function hentDato(maaned: Valg<string> | undefined, aar: Valg<string> | undefined): Date {

        if(maaned === undefined || aar === undefined)
            return new Date();

        const dato: Date = new Date(aar.id+"-"+maaned.id+"-01");
        return dato; 
    }

    function visDatoFeilmelding(): void {
        setIsInErrorState(true);
        focusInputElementOnError({ id: 'js-veileder__fratilDato_feilmelding', errorClass: 'c-text-input--feil' });
    }

    function skjulDatoFeilmelding(): void {
        setIsInErrorState(false);
        let cont = document.getElementById("js-veileder__fratilDato_feilmelding");
        cont?.classList.remove("c-text-input--feil");
    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={props.forklaring}
            canCollapse={props.value != null}
            displayElement={<div className="c-veileder__valgt-item">
                <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
            </div>}
            inputArea={
                <div className="c-veileder__inputomrade">
                    <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken c-select-options-small c-select-options__label-override" id="js-veileder__fratilDato_feilmelding">                      
                        <fieldset className="c-veileder__fieldset">
                            <LegendWithErrorComponent
                                feilMeldingsId={FEILMELDING_PERIODE_ID_DEL_GRAD}
                                showError={isInErrorState}
                                errorElement={contentResolver(epiContext, 'steg4FeilMedDato')}
                            >
                                {props.ledetekst}
                            </LegendWithErrorComponent>

                            <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken">
                                <SelectOptionDisplay
                                    buttonProps={{ 'aria-describedby': FEILMELDING_PERIODE_ID_DEL_GRAD }}
                                    htmlId={props.sporsmalId+'-fra-select-maaned'}
                                    ledetekst={contentResolver(epiContext, 'steg4LedetekstFraManed')}
                                    options={hentMaanedListe()}
                                    onSelectChange={(nyttFraValg: Valg<string>): void => {
                                        onSelectFraMaanedHandling(nyttFraValg);
                                    }}
                                    showSearch={false}
                                    value={inputFraManed}
                                />
                            </div>
                            <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken">
                                <SelectOptionDisplay
                                    buttonProps={{ 'aria-describedby': FEILMELDING_PERIODE_ID_DEL_GRAD }}
                                    htmlId={props.sporsmalId+'-fra-select-aar'}
                                    ledetekst={contentResolver(epiContext, 'steg4LedetekstFraAar')}
                                    options={hentFraAarListe()}
                                    onSelectChange={(nyttFraValg: Valg<string>): void => {
                                        onSelectFraAarHandling(nyttFraValg);
                                    }}
                                    showSearch={false}
                                    value={inputFraAar}
                                />
                            </div>
                            <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken">
                                <SelectOptionDisplay
                                    buttonProps={{ 'aria-describedby': FEILMELDING_PERIODE_ID_DEL_GRAD }}
                                    htmlId={props.sporsmalId+'-til-select-maaned'}
                                    ledetekst={contentResolver(epiContext, 'steg4LedetekstTilManed')}
                                    options={hentMaanedListe()}
                                    onSelectChange={(nyttTilValg: Valg<string>): void => {
                                        onSelectTilMaanedHandling(nyttTilValg);
                                    }}
                                    showSearch={false}
                                    value={inputTilManed}
                                />
                            </div>
                            <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken">
                                <SelectOptionDisplay
                                    buttonProps={{ 'aria-describedby': FEILMELDING_PERIODE_ID_DEL_GRAD }}
                                    htmlId={props.sporsmalId+'-til-select-aar'}
                                    ledetekst={contentResolver(epiContext, 'steg4LedetekstTilAar')}
                                    options={hentTilAarListe()}
                                    onSelectChange={(nyttTilValg: Valg<string>): void => {
                                        onSelectTilAarHandling(nyttTilValg);
                                    }}
                                    showSearch={false}
                                    value={inputTilAar}
                                />
                            </div>
                        </fieldset>
                    </div>
                    <div className="c-veileder__content--cta-area">
                        <button onClick={buttonClickHandler} className="c-knapp c-knapp--cta c-knapp--secondary">{contentResolver(epiContext, 'steg4Knappetekst')}</button>
                    </div>
                </div>
            }
            sporsmalId={props.sporsmalId}
        />
    )
}

interface MapStateToProps {
    epiContext: EpiContext<ForelopigUttalelseSkjemaSideDto>;
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: ForelopigUttalelseSkjemaSideAppState, ownProps: Steg4bComponentOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
            epiContext: state.epiContext,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(Steg4bComponentVisning);